import { WhatIfGlobalSetsPage } from '@/pages/what-if/global-pc-sets'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/whatif/sets')({
	component: WhatIfGlobalSetsPage,
})
